import styled from 'styled-components'
import { Button } from '~components'
import ShowPasswordSvg from '~components/svgs/ShowPassword'
import HidePasswordSvg from '~components/svgs/HidePassword'

export const LinkButton = styled(Button)`
  margin-top: ${({ theme }) => theme.spacing.km1};
`

export const ShowPassword = styled(ShowPasswordSvg)`
  cursor: pointer;
`

export const HidePassword = styled(HidePasswordSvg)`
  cursor: pointer;
`
